import { Component } from 'react';
import SurveyQuizSelectLayout from './SurveyQuizSelectLayout';

class SurveyQuizSelect extends Component {
  render() {
    return (
      <SurveyQuizSelectLayout 
        {...this.props} 
        {...this.state}
      />
    );
  }
}

export default SurveyQuizSelect;
